var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number"},[_c('div',{staticClass:"number-digits"},_vm._l((_vm.digits),function(digit,index){return _c('digit',{key:(index + "-" + digit),attrs:{"value":digit}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }